/**
 *  @class
 *  @function FreeShippingProgressBar
 */

if (!customElements.get('free-shipping-progress-bar')) {
    class FreeShippingProgressBar extends HTMLElement {
      constructor() {
        super();
        this.currentPercent = 0;
      }

      connectedCallback() {
        // Start the animation from the server rendered fill so the bar does not jump back to 0.
        this.currentPercent = parseFloat(this.style.getPropertyValue('--percent')) || 0;
        this.updateStatus();
      }

      updateStatus() {
        const remainingAmountText = this.querySelector('.free-shipping__info-text strong');
        const cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
        const freeShippingThreshold = Math.round(parseInt(this.dataset.shippingAmount, 10) * (Shopify.currency.rate || 1));
        const isEligible = freeShippingThreshold <= 0 || cartTotal >= freeShippingThreshold;

        if (remainingAmountText && !isEligible) {
          const remainingAmount = freeShippingThreshold - cartTotal;
          const currencyFormat = window.theme.settings.money_with_currency_format || "${{amount}}";
          remainingAmountText.innerHTML = formatMoney(remainingAmount, currencyFormat);
        }

        this.classList.toggle('is-complete', isEligible);

        const progressPercentage = isEligible ? 1 : cartTotal / freeShippingThreshold;
        this.animateProgressBar(progressPercentage);
      }

      animateProgressBar(progressPercentage) {
        const targetPercent = progressPercentage * 100;
        const startPercent = this.currentPercent;
        const duration = 200;
        const startTime = performance.now();

        const ease = (t) => t * (2 - t);

        const animate = (time) => {
          const elapsed = time - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easedProgress = ease(progress);

          this.currentPercent = startPercent + (targetPercent - startPercent) * easedProgress;
          this.style.setProperty('--percent', `${this.currentPercent}%`);

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            this.currentPercent = targetPercent;
            this.style.setProperty('--percent', `${this.currentPercent}%`);
          }
        };

        requestAnimationFrame(animate);
      }
    }

    customElements.define('free-shipping-progress-bar', FreeShippingProgressBar);
}
